// test2198
(2198 && 0);
